module.exports = __webpack_public_path__ + "static/imediateaccess-741d6ff0849682eaa29747f366e7bf3d.png";